import React from 'react'
import '../base/Theme.css';
import './Error.css';

function Error() {
    return (
        <div className="Error">
            Oops. Some error happened.
        </div>
    );
}

export default Error;
